import React, {FC, memo} from 'react';

// eslint-disable-next-line import/no-cycle -- please fix if you can
import {RunSummaryProps} from '../pages/Run/RunOverview';
import * as Runs from '../util/runs';
import {SearchableJSONTree} from './SearchableJSONTree/SearchableJSONTree';

export const RunSummaryTree: FC<RunSummaryProps> = memo(
  ({summary, projectName, entityName, userID, viewRawData}) => {
    // TODO: not sure what's going on here. consolidate this logic (including Runs.cleanSummary) and move it to SearchableJSONTree filter option
    const cleanedSummary = Object.entries(Runs.cleanSummary(summary)).reduce(
      (acc: {[key: string]: any}, [key, value]) => {
        if (
          key !== '_runtime' &&
          key !== '_step' &&
          key !== '_timestamp' &&
          !key.startsWith('gradients/') &&
          !key.startsWith('_wandb.') &&
          !key.startsWith('parameters/')
        ) {
          if (value?._type === 'table-file') {
            acc[key] = 'table-file';
          } else {
            acc[key] = value;
          }
        }
        return acc;
      },
      {}
    );
    return (
      <SearchableJSONTree
        rootKeyLabel="Summary metrics"
        json={cleanedSummary}
        // TODO: get viewRawData working again
        viewRawData={viewRawData}
        eventData={{
          projectName,
          entityName,
          userID,
        }}
      />
    );
  }
);
RunSummaryTree.displayName = 'RunSummaryTree';
